module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/instagram/suns_sns_06-e8b9c9b452f543d44f30d06ac18e7d1d.jpg";